export const CITIES = [
  {
    slug: "wuppertal",
    name: "Wuppertal",
    region: "Nordrhein-Westfalen",
    plz: "42103–42399",
    intro:
      "Als lokaler Fachpartner installieren wir Ihre Wärmepumpe in Wuppertal – von Elberfeld über Barmen bis Vohwinkel. Wir kennen die typische Altbau- und Hanglagen-Bausubstanz der Stadt und finden die passende Lösung.",
    districts: ["Elberfeld", "Barmen", "Cronenberg", "Ronsdorf", "Vohwinkel"],
  },
  {
    slug: "duesseldorf",
    name: "Düsseldorf",
    region: "Nordrhein-Westfalen",
    plz: "40210–40629",
    intro:
      "Wärmepumpen-Installation in Düsseldorf: Ob Altbau in Pempelfort oder Neubau in Kaiserswerth – unsere zertifizierten Fachpartner beraten Sie herstellerunabhängig und übernehmen die komplette Förderabwicklung.",
    districts: ["Pempelfort", "Oberkassel", "Bilk", "Gerresheim", "Kaiserswerth"],
  },
  {
    slug: "duisburg",
    name: "Duisburg",
    region: "Nordrhein-Westfalen",
    plz: "47051–47279",
    intro:
      "Ihre neue Wärmepumpe in Duisburg – effizient, gefördert und zum Festpreis. Wir installieren im gesamten Stadtgebiet von Hamborn bis Rheinhausen und sichern Ihnen bis zu 70% staatliche Förderung.",
    districts: ["Hamborn", "Meiderich", "Rheinhausen", "Hochfeld", "Duissern"],
  },
  {
    slug: "essen",
    name: "Essen",
    region: "Nordrhein-Westfalen",
    plz: "45127–45359",
    intro:
      "Wärmepumpen-Installation in Essen: Vom Altbau in Rüttenscheid bis zum Reihenhaus in Borbeck finden unsere zertifizierten Fachpartner die passende Lösung – inklusive kompletter Förderabwicklung.",
    districts: ["Rüttenscheid", "Borbeck", "Steele", "Kettwig", "Altenessen"],
  },
  {
    slug: "koeln",
    name: "Köln",
    region: "Nordrhein-Westfalen",
    plz: "50667–51149",
    intro:
      "Wärmepumpe in Köln installieren lassen – ob Altbau in Ehrenfeld oder Neubau in Sülz. Wir übernehmen Beratung, Förderantrag und Installation zum garantierten Festpreis.",
    districts: ["Ehrenfeld", "Nippes", "Lindenthal", "Deutz", "Sülz"],
  },
  {
    slug: "dortmund",
    name: "Dortmund",
    region: "Nordrhein-Westfalen",
    plz: "44135–44388",
    intro:
      "Ihre Wärmepumpe in Dortmund – gefördert mit bis zu 70% und zum Festpreis. Unsere lokalen Fachpartner installieren im gesamten Stadtgebiet von Hörde bis Eving.",
    districts: ["Hörde", "Aplerbeck", "Hombruch", "Eving", "Brackel"],
  },
];

export const getCity = (slug) => CITIES.find((c) => c.slug === slug);
